
var Navbar = (function() {

    function Navbar(id) {
        var self = this;
        this.el = document.getElementById(id);
        this.toggle = this.el.getElementsByClassName('c-navbar-toggle')[0];
        this.menu = this.el.getElementsByClassName('c-navbar-menu-wrapper')[0];
        this.toggle.addEventListener('click', function(event) {
            event.preventDefault();
            self.menu.classList.toggle('c-navbar-menu-wrapper-hidden');
            self.toggle.classList.toggle('c-navbar-toggle-active');
        });
    }

    return Navbar;
}());

export default Navbar;
